/* eslint-disable */
import qs from 'qs'

import request from '@/utils/request'

export function getListOooRoomApi(query) {
  return request({
    url: '/chamber-service/v1/ooo_oos/list',
    method: 'get',
    params: query
  })
}
export function addOooRoomApi(query, data) {
  return request({
    url: '/chamber-service/v1/ooo_oos',
    method: 'post',
    params: query,
    paramsSerializer: query => qs.stringify(query, { arrayFormat: 'repeat' }),
    data: data
  })
}
export function updateOooRoomApi(query) {
  return request({
    url: '/chamber-service/v1/ooo_oos',
    method: 'put',
    data: query
  })
}
export function deleteOooRoomApi(query) {
  return request({
    url: '/chamber-service/v1/ooo_oos',
    method: 'delete',
    data: query
  })
}
export function getOooOosDetailApi(id) {
  return request({
    url: `/chamber-service/v1/ooo_oos/${id}`,
    method: 'get'
  })
}

export function getAvaiableRoomList(params) {
  return request({
    url: '/chamber-service/v1/ooo_oos/listRoom',
    method: 'get',
    params: params
  })
}
